import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _QualityInformationILES, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_BOOLEAN } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import usePaginator from "../../../theme/Component/usePaginator";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { FileInput } from "../../../theme/Component/FileInput";
import { FileService } from "../../../../core/services/FileService";
import { SelectProductEditor } from "../../ManufacturingStandars/Components/SelectProductEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { DropDown } from "../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";

interface ComponentProps {
    isModal?: boolean;
    notModify?: boolean;
}

interface formData {
    NoContact: string;
    DeliveryType: number;
    IDProduct: number;
    FromDate: any;
    UptoDate: any;
    Satisfy: number;
}

export const QualityInformationILES = ({ notModify, isModal }: ComponentProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInformationILES);
    const paginator = usePaginator();
    const fileservice = new FileService();

    const [form, setForm] = useState<Partial<formData>>({})

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar revisión ILES', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalDocument = useModal("Cargar Documento Firmado", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);
    const modalGraph = useModal("Reporte Excel", MODAL_SM);

    const [listaExport, setListaExport] = useState<any[]>([]);

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getListaExport = () => {
        const props: any = {
            State: 1
        }

        if (form.DeliveryType) props.IDDeliveryType = form.DeliveryType;
        if (form.IDProduct) props.IDProduct = form.IDProduct;
        if (form.NoContact) props.NoContract = form.NoContact;
        if (form.Satisfy) props.Satisfy = form.Satisfy;

        instance.getQualityInformationILESRender(1, paginator.pages * 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.Satisfy = data.Satisfy ? "Si" : "No"
                });
                setListaExport(resp.List)
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    const getLista = () => {
        const props: any = {
            State: 1
        }

        if (form.DeliveryType) props.IDDeliveryType = form.DeliveryType;
        if (form.IDProduct) props.IDProduct = form.IDProduct;
        if (form.NoContact) props.NoContract = form.NoContact;
        if (form.Satisfy || form.Satisfy === 0) props.Satisfy = form.Satisfy;

        instance.getQualityInformationILESRender(paginator.page, 15, props, form.FromDate, form.UptoDate).then((resp: any) => {
            paginator.setPages(resp.NumberOfPages);
            paginator.setRecords(resp.NumberOfPages * 15);
            setLista(resp.List)
        }).catch(err => {
            toast.error("Error al cargar la lista Tipos de errores");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            Satisfy: false,
        });
        setModal({ ...modal, "name": `Agregar revisión ILES`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateQualityInformationILES(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityInformationILES', visible: true },
        { title: 'Contrato', property: 'NoContract', visible: true },
        { title: 'No ILES', property: 'NoILE', visible: true },
        { title: 'Tipo de Entrega', property: 'DeliveryTypeName', visible: true },
        { title: 'Lote', property: 'Lot', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Numero de Muestras', property: 'NumberSample', visible: true },
        { title: 'Fecha de Documento', property: 'ReviewDate', visible: true },
        { title: '¿Cumple?', property: 'Satisfy', visible: true, mask: MASK_BOOLEAN },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!notModify), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!notModify), evento: () => { setModal({ ...modal, "name": `Editar revisión ILES`, "view": true }) } },
            { titulo: 'Cargar Documento Firmado', icono: 'mdi mdi-file-upload', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.DocMedia, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && (!notModify), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            console.log(missingFields)
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "ReviewDate", "NoContract", "IDProduct", "Lot", "NumberSample", "IDDeliveryType",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const rowContent = (
        <div className="row">
            <div className="col-md-4">
                <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
            </div>
            <div className="col-md-4">
                <InputDate name="" value={form.UptoDate} label="Fecha hasta" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
            </div>
            <div className="col-md-4">
                <SelectProductEditor label="Producto" value={form.IDProduct} onChange={(e) => { setForm({ ...form, IDProduct: e.IDProduct }) }} />
            </div>
            <div className="col-md-4">
                <SelectTHConstantsValue label="Tipo de Entrega" code={906} onChange={(e) => { setForm({ ...form, DeliveryType: e }) }} value={form.DeliveryType} />
            </div>
            <div className="col-md-4">
                <label>Cumplimiento</label>
                <select value={form.Satisfy} className="form-control" onChange={(e) => {
                    const value = e.target.value ? Number(e.target.value) : null;
                    setForm({ ...form, Satisfy: value })
                }}>
                    <option value="">...</option>
                    <option value="1">Cumple</option>
                    <option value="0">No Cumple</option>
                </select>
            </div>
            <div className="col-md-2">
                <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} useMargin />
            </div>
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    iconButtons={iconButtonsItem}
                />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('NoILE') ? 'has-error' : ''}`} >No. ILE</label>
                            <input className="form-control" type="text" value={bean.NoILE} onChange={(e) => { setBean({ ...bean, NoILE: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('ReviewDate') ? 'has-error' : ''}`} >Fecha de Documento</label>
                            <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('NoContract') ? 'has-error' : ''}`} >No de Contrato</label>
                            <input type="text" value={bean.NoContract} onChange={(e) => { setBean({ ...bean, NoContract: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`} >Producto</label>
                            <SelectProductEditor renderValue="" label=" " value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Lot') ? 'has-error' : ''}`} >Lote</label>
                            <input type="text" value={bean.Lot} onChange={(e) => { setBean({ ...bean, Lot: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('NumberSample') ? 'has-error' : ''}`} >Numero de Muestras</label>
                            <input type="number" value={bean.NumberSample} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, NumberSample: value })
                            }} className="form-control" />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDDeliveryType') ? 'has-error' : ''}`} >Tipo de Entrega</label>
                            <SelectTHConstantsValue label=" " code={906} onChange={(e) => { setBean({ ...bean, IDDeliveryType: e }) }} value={bean.IDDeliveryType} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={bean.Satisfy} eventChange={(e) => { setBean({ ...bean, Satisfy: e }) }} label="¿Cumple?" />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} className="form-control"></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <div className="row">
                        <div className="col">
                            {lista.length > 0 &&
                                <ExportXLSL customName={"ILESReport"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.TechnicianName}</strong>
                </ModalConfirm>

                <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { editaItem(bean) }}  >
                    <FileInput onCreate={(e) => { setBean({ ...bean, DocMedia: e.Media, DocMediaContext: e.MediaContext }) }} Media={bean.DocMedia} MediaContext={bean.DocMediaContext} directory="quality" docAcept={"application/pdf"} label="Documento Firmado" />
                </Modal>

                <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                    <VisorAnyDocument type="pdf" url={fileservice.getUrlFile(bean.DocMediaContext, bean.DocMedia)} />
                </Modal>
            </div>
        </div>
    )

    return isModal ? rowContent : (
        <BasicPage titulo="Calidad - ILES">
            {rowContent}
        </BasicPage>
    )
}